var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-count"},[_c('span',{staticClass:"count"},[_vm._v(" "+_vm._s((_vm.count === 0 || _vm.isLoading || _vm.loadingError) ? '' : _vm.count)+" ")]),_c('span',[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }